import { ObjectValues } from '../types';

export const sizes = {
  headline1: 'headline1',
  headline2: 'headline2',
  headline3: 'headline3',
  large: 'large',
  basic: 'basic',
  small: 'small',
  interface: 'interface',
  button: 'button',
  section: 'section',
} as const;

export const themes = {
  normal: 'normal',
  emphasis: 'emphasis',
  headline: 'headline',
} as const;

// NOTE: The type of the rest spread properties is generic because `elementName` can be _any_ HTML element which we can't type the props for
export type Text = {
  className?: string;
  elementName?: string;
  italic?: boolean;
  size?: ObjectValues<typeof sizes>;
  theme?: ObjectValues<typeof themes>;
  tight?: boolean;
} & { [key: string]: unknown };
